import axios from "axios";
export const DateFormat = (date) => {
  if (String(date).includes("-")) {
    return date;
  }
  const day = String(date.getDate()).padStart(2, "0"); //   day
  const month = String(date.getMonth() + 1).padStart(2, "0"); //   month
  const year = date.getFullYear(); //   year

  return `${year}-${month}-${day}`;
};

export const isValidDateFormat = (dateStr) => {
  const dateParts = dateStr.split("/");
  if (dateParts.length !== 3) return false;

  const day = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10) - 1;
  const year = parseInt(dateParts[2], 10);

  const date = new Date(year, month, day);

  return (
    date &&
    date.getDate() === day &&
    date.getMonth() === month &&
    date.getFullYear() === year
  );
};

export const NSWSDateFormat = (dateStr) => {
  if (dateStr == "2000-01-01T00:00:00") {
    return "";
  } else if (dateStr == "null") {
    return "";
  }
  const dateObj = new Date(dateStr);

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = dateObj.getFullYear();

  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
};
export function getMonthInfo(input) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  if (typeof input === "string") {
    // Convert month name to month number
    const monthIndex = months.findIndex(
      (month) => month.toLowerCase() === input.toLowerCase()
    );
    return monthIndex === -1 ? "Invalid month name" : monthIndex + 1;
  } else if (typeof input === "number") {
    // Convert month number to month name
    return input < 1 || input > 12 ? "Invalid month number" : months[input - 1];
  } else {
    return "Invalid input type";
  }
}

// The user's public IP (sent with every save) is looked up once per login and
// kept in localStorage "ip"; later calls reuse the same lookup.
let staticIpRequest = null;

export const getStaticIP = () => {
  if (!staticIpRequest) {
    staticIpRequest = axios
      .get("https://api.ipify.org?format=json")
      .then((response) => {
        localStorage.setItem("ip", response.data.ip);
      })
      .catch((error) => {
        staticIpRequest = null; // try again on the next call
        console.error("Could not get the public IP:", error);
      });
  }
  return staticIpRequest;
};

/** Forgets the lookup so the next call fetches the IP again (on logout). */
export const clearStaticIP = () => {
  staticIpRequest = null;
};
